import React, { useState } from 'react';
import { isArray } from '../helpers/typeOf';
import GenFileChooser from './GenFileChooser';

const GenFileUpload = ({
  variant = 'normal',
  currentFiles = [],
  accept = [],
  multiple = false,
  maxSize = null,
  uploadUrl = '',
  amplifyApi,
  onChangeLoading = () => {},
  onChange,
}) => {
  const [files, setFiles] = useState([...currentFiles]);

  const setFilesAndEmitChange = newFiles => {
    onChangeLoading(false);
    onChange(newFiles);
    setFiles(newFiles);
  };

  const detailsByStatus = {
    uploading: () => 'Loading...',
    error: () => 'Error',
    success: file => `${file.size / 1000} KB`,
  };

  const projectFileToModel = (file, status = 'uploading') => {
    return {
      fileId: file.fileId || file.name,
      fileName: file.fileName || file.name,
      status,
      type: file.fileName?.split('.').pop() || file.name?.split('.').pop(),
      details: detailsByStatus[status](file),
      size: file.size,
    };
  };

  const findFileInProcessedFiles = (filesProcessed, file) => {
    return (
      filesProcessed.find(
        fileProcessed => fileProcessed.originalFilename === file.fileName
      ) || {}
    );
  };

  const sendFilesToAPI = newFiles => {
    const projectedNewFiles = [
      ...files,
      ...newFiles.map(file => projectFileToModel(file)),
    ];
    setFiles(projectedNewFiles);

    const formDataFiles = new FormData();
    newFiles.forEach(file => formDataFiles.append('files', file));

    onChangeLoading(true);

    amplifyApi(formDataFiles, uploadUrl, 'post')
      .then(response => {
        const processedFiles = isArray(response) ? response : [response];
        setFilesAndEmitChange([
          ...projectedNewFiles.map(file =>
            projectFileToModel(
              {
                ...file,
                ...findFileInProcessedFiles(processedFiles, file),
              },
              'success'
            )
          ),
        ]);
      })
      .catch(ex => {
        setFilesAndEmitChange([
          ...files,
          ...newFiles.map(file => projectFileToModel(file, 'error')),
        ]);
      });
  };

  const deleteFile = fileToDelete => {
    setFilesAndEmitChange(
      files.filter(file => file.fileId !== fileToDelete.fileId)
    );
  };

  return (
    <GenFileChooser
      variant={variant}
      accept={accept}
      files={files}
      multiple={multiple}
      maxSize={maxSize}
      onChange={newFiles => sendFilesToAPI(newFiles)}
      onDeleteFile={fileToDelete => deleteFile(fileToDelete)}
    />
  );
};

export default GenFileUpload;
